/**
 * 지점주 과제 관리 페이지 (/owner/report)
 *
 * 강사 Homework와 UI는 유사하지만 전체 Report 트리 편집 + 지점 배포(ReportAssignBranch) 담당
 */
import styled from "styled-components";
import MenuBar from "features/homework/components/MenuBar";
import FOLDER_ADD_SVG from "assets/images/folder_add.svg";
import FILE_ADD_SVG from "assets/images/file_add.svg";
import TRASHCAN_SVG from "assets/images/trashcan.svg";
import PENCIL_SVG from "assets/images/pencil.svg";
import UPLOAD_SVG from "assets/images/file_upload.svg";
import DEPLOY_SVG from "assets/images/deploy.svg";
import FolderView from "features/homework/components/FolderView";
import useReport from "features/homework/hooks/useReport";
import ReportView from "features/homework/components/ReportView";
import ReportModal from "features/homework/components/ReportModal";
import ReleaseView from "features/homework/components/ReleaseView";
import Modal from "shared/components/Modal";
import { useState } from "react";
import TOGGLE_SVG from "assets/images/toggle.svg";

const Report = () => {
  const { reportError, clearReportError, selectedMenu, onMenuItemClickHandler, onSubMenuItemClickHandler, folderList, onFolderClick, nowFolder,
     onPrevClickHandler, selectedReport, onFolderSelectClickHandler, onFolderSelectAllClickHandler, selectedFolderList,
     isOpenReportModal, modalInput, onReportModalInputChangeHandler, onReportModalConfirmClickHandler, onReportModalCancelClickHandler,
     isOpenFolderDeleteModal, onFolderDeleteConfirmClickHandler, onFolderDeleteCancelClickHandler
   } = useReport();
  const [isFolderVisible, setIsFolderVisible] = useState(true);

  const menuList = [
    {
      id: 1,
      name: "과제 등록",
      icon: UPLOAD_SVG
    },
    {
      id: 2,
      name: "과제 배포",
      icon: DEPLOY_SVG,
    }
  ]

  const subMenuList = [
    {
      id: 1,
      name: "폴더 추가",
      icon: FOLDER_ADD_SVG
    },
    {
      id: 2,
      name: "과제 추가",
      icon: FILE_ADD_SVG
    },
    {
      id: 3,
      name: "이름 수정",
      icon: PENCIL_SVG,
    },
    {
      id: 4,
      name: "삭제",
      icon: TRASHCAN_SVG,
    }
  ]

  return (
    <Container>
      <Modal isOpen={Boolean(reportError)} title="ERROR" content={reportError} onClose={clearReportError}/>
      <ReportModal isOpen={isOpenReportModal} onChange={onReportModalInputChangeHandler} value={modalInput} onConfimClickHandler={onReportModalConfirmClickHandler} onCancelClickHandler={onReportModalCancelClickHandler}/>
      <Modal isOpen={isOpenFolderDeleteModal} title="경고" content="확인을 누르시면 선택된 폴더들이 삭제됩니다" onConfirm={onFolderDeleteConfirmClickHandler} onClose={onFolderDeleteCancelClickHandler}/>
      <MenuBar menuList={menuList} onMenuItemClickHandler={onMenuItemClickHandler} selectedMenu={selectedMenu} />
      <ContentContainer>
        {selectedMenu === 1 ? (
          <>
            <FolderContainer isVisible={isFolderVisible}>
              <FolderView 
                folderList={folderList} 
                onFolderClick={onFolderClick} 
                nowFolder={nowFolder} 
                onPrevClickHandler={onPrevClickHandler} 
                selectedReport={selectedReport}
                onSelectClickHandler={onFolderSelectClickHandler}
                onSelectAllClickHandler={onFolderSelectAllClickHandler}
                selectedFolderList={selectedFolderList}
                actions={subMenuList}
                onActionClick={onSubMenuItemClickHandler}
              />
            </FolderContainer>
            <ToggleButton
              onClick={() => setIsFolderVisible(v => !v)}
              isVisible={isFolderVisible}
            >
              <img src={TOGGLE_SVG} alt="toggle" />
            </ToggleButton>
            <ReportContainer>
              <ReportView nowFolder={nowFolder} selectedReport={selectedReport}/>
            </ReportContainer>
          </>
        ) : (
          <ReportContainer>
            <ReleaseView />
          </ReportContainer>
        )}
      </ContentContainer>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`

const ContentContainer = styled.div`
  display: flex;
  flex-grow: 1;
  width: 100%;
  min-width: 0;
  min-height: 0;
  position: relative;
  overflow: hidden;
`

const FolderContainer = styled.div<{ isVisible: boolean }>`
  width: ${props => props.isVisible ? '360px' : '0'};
  min-width: ${props => props.isVisible ? '360px' : '0'};
  max-width: 360px;
  height: 100%;
  transition: width 0.3s, min-width 0.3s;
  overflow: hidden;
  border-right: 1px solid #E2E8F0;
  flex-shrink: 0;
  background: #FFFFFF;
  z-index: 2;
`

const ReportContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background: #F8FAFC;
`

const ToggleButton = styled.button<{ isVisible: boolean }>`
  position: absolute;
  left: ${props => props.isVisible ? '360px' : '0'};
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 56px;
  background-color: white;
  border: 1px solid #E2E8F0;
  border-left: none;
  border-radius: 0 10px 10px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: left 0.3s, background 0.15s;
  z-index: 10;
  padding: 0;
  box-shadow: 4px 0 12px rgba(15, 23, 42, 0.06);

  img {
    width: 14px;
    height: 14px;
    transform: ${props => props.isVisible ? 'rotate(0deg)' : 'rotate(180deg)'};
    transition: transform 0.3s;
  }

  &:hover {
    background-color: #FEF2F2;
  }
`

export default Report;
